import { AppManagerState } from '@/store/modules/app-manager/types';
import Vue from 'vue';
import Vuex, { Store } from 'vuex';
import { deskModule, DeskState } from '@/store/modules/desk';
import { appManagerModule } from '@/store/modules/app-manager/app-manager';

export interface RootState {
    desk: DeskState;
    appManager: AppManagerState;
}

Vue.use(Vuex);

const store = new Store<RootState>({});
store.registerModule('desk', deskModule);
store.registerModule('appManager', appManagerModule);

export default store;
